import {
  Box,
  Card,
  Group,
  Stack,
  Text,
  ThemeIcon,
  Title,
  Tooltip
} from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'
import { ReactNode } from 'react'

type SettingsCardProps = {
  title: ReactNode
  description?: ReactNode
  tooltip?: ReactNode
  contentMaxWidth?: number
  children: ReactNode
}
export const SettingsCard = ({
  title,
  description,
  tooltip,
  contentMaxWidth,
  children
}: SettingsCardProps) => {
  return (
    <Stack gap="sm">
      <Stack gap={4}>
        <Group align="center" wrap="nowrap" gap={4}>
          <Title order={5}>{title}</Title>

          {tooltip && (
            <Tooltip w={320} label={tooltip} multiline>
              <ThemeIcon variant="transparent" radius="xl" size="xs">
                <IconInfoCircle style={{ width: '100%', height: '100%' }} />
              </ThemeIcon>
            </Tooltip>
          )}
        </Group>

        {description && (
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        )}
      </Stack>

      <Card bg="gray.0" padding="lg">
        <Box maw={contentMaxWidth}>{children}</Box>
      </Card>
    </Stack>
  )
}
